/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Compare_Event_Groups_Alignment_LabelInputs */



/**
* | output |
* | --- |
* | "Alignment {index}" |
*
* @param {Compare_Event_Groups_Alignment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_alignment_label = /** @type {((inputs: Compare_Event_Groups_Alignment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Alignment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Alignement ${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ausrichtung ${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Allineamento ${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выравнивание ${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Alineación ${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`对齐方式 ${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アライメント ${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`संरेखण ${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Alinhamento ${i?.index}`)
	return /** @type {LocalizedString} */ (`Alignment ${i?.index}`)
});